/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentWaitlistEntrySchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  teamId: z.string().nullish(),
  get team() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  position: z.optional(z.int()),
  joinedAtUtc: z.optional(z.iso.datetime()),
  promotionSkippedReason: z.string().nullish(),
  promotionSkippedAtUtc: z.iso.datetime().nullish(),
});
